var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternetBlueBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 4,
    fill: "#6856DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 33C28.4036 33 34 27.4036 34 20.5C34 13.5964 28.4036 8 21.5 8C14.5964 8 9 13.5964 9 20.5C9 27.4036 14.5964 33 21.5 33Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 33C24.9518 33 27.75 27.4036 27.75 20.5C27.75 13.5964 24.9518 8 21.5 8C18.0482 8 15.25 13.5964 15.25 20.5C15.25 27.4036 18.0482 33 21.5 33Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 8V33",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 26.75C28.4036 26.75 34 23.9518 34 20.5C34 17.0482 28.4036 14.25 21.5 14.25C14.5964 14.25 9 17.0482 9 20.5C9 23.9518 14.5964 26.75 21.5 26.75Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 20.5H9",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetBlueBg);
export default __webpack_public_path__ + "static/media/InternetBlueBG.211bcd2da508f337dc9e835859caa03e.svg";
export { ForwardRef as ReactComponent };